// extracted by mini-css-extract-plugin
export var buttons = "_47-0";
export var buttonsActive = "_47-h";
export var cancelConfirm = "_47-1";
export var closeButton = "_47-2";
export var column = "_47-3";
export var container = "_47-4";
export var detailHeader = "_47-6";
export var detailTitle = "_47-7";
export var detailsContent = "_47-5";
export var header = "_47-8";
export var headerWithClose = "_47-9";
export var icon = "_47-a";
export var infoIcon = "_47-c";
export var informationContainer = "_47-b";
export var sideDrawer = "_47-d";
export var sideDrawerOpen = "_47-e";
export var stickyFooter = "_47-f";
export var typeOption = "_47-g";